// extracted by mini-css-extract-plugin
export default {"form":"InformationForm_form__vcX5H","button":"InformationForm_button__SFYRC","formGroup":"InformationForm_formGroup__d+6Rk","editor":"InformationForm_editor__k248W"};